/*
 * action types
*/

export const REPLACE = "REPLACE_REFERRALITEMS";
export const CLEAR = "CLEAR_REFERRALITEMS";
export const SET_FILTERS = "SET_REFERRALSITEM_FILTERS";
export const SET_PAGESIZE = "SET_REFERRALSITEM_PAGESIZE";
export const SET_PAGENUMBER = "SET_REFERRALSITEM_PAGENUMBER";

/*
 * action creators
*/

export const Replace = (referralItems, totalResults, totalPage) => ({ 
    type : REPLACE,
    referralItems,
    totalResults,
    totalPage,
});

export const Clear = () => ({
    type: CLEAR
})

export const SetPageSize = (pageSize) => ({
    type: SET_PAGESIZE,
    pageSize
})

export const SetPageNumber = (pageNumber) => ({
    type: SET_PAGENUMBER,
    pageNumber
})

export const SetFilters = (filters) => ({
    type: SET_FILTERS,
    filters
})